import type { Enums, Nullable, WebfleetOrderType } from "../types";

/**
 * This function returns the translation key for a given Webfleet order type.
 * @param orderType
 * @returns
 */
export function getWebfleetOrderTypeColor(orderType: Nullable<WebfleetOrderType>): Enums<"color"> {
	switch (orderType) {
		case 1:
			return "emerald";
		case 2:
			return "indigo";
		case 3:
			return "rose";
		default:
			return "gray";
	}
}
